import React from 'react';
import { Link } from 'react-router-dom';
export const Footer = () => {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gray-50 border-t border-gray-100 py-12 md:py-16" data-id="element-31">
      <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-32">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-8 md:mb-12" data-id="element-33">
          <div data-id="element-34">
            <div className="text-xl md:text-2xl font-light mb-3 md:mb-4" data-id="element-35">
              WELLHAUS™
            </div>
            <p className="text-xs md:text-sm text-gray-600 leading-relaxed" data-id="element-36">
              Premium water. Elevated experience.
            </p>
          </div>
          <div data-id="element-37">
            <h4 className="text-xs md:text-sm font-medium mb-3 md:mb-4 uppercase tracking-wider" data-id="element-38">
              Contact
            </h4>
            <div className="space-y-1.5 md:space-y-2 text-xs md:text-sm text-gray-600" data-id="element-39">
              <a href="mailto:wellhaus@smartsoda.com" className="block hover:text-gray-900 transition-colors" data-id="element-40">
                wellhaus@smartsoda.com
              </a>
            </div>
          </div>
          <div data-id="element-41">
            <h4 className="text-xs md:text-sm font-medium mb-3 md:mb-4 uppercase tracking-wider" data-id="element-42">
              Get Started
            </h4>
            <div className="space-y-1.5 md:space-y-2 text-xs md:text-sm" data-id="element-43">
              <a href="https://form.typeform.com/to/rfYM00cT" target="_blank" rel="noopener noreferrer" className="block text-gray-600 hover:text-gray-900 transition-colors" data-id="element-44">
                Request a Demo
              </a>
              <a href="https://calendly.com/-smartsoda/discoverycall" target="_blank" rel="noopener noreferrer" className="block text-gray-600 hover:text-gray-900 transition-colors" data-id="element-45">
                Talk to Our Team
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-200 pt-6 md:pt-8 flex flex-col md:flex-row justify-between items-center gap-3 md:gap-4" data-id="element-46">
          <p className="text-xs text-gray-500" data-id="element-47">
            © {currentYear} WELLHAUS. All rights reserved.
          </p>
          <div className="flex gap-4 md:gap-6 text-xs text-gray-500" data-id="element-48">
            <a href="#" className="hover:text-gray-900 transition-colors" data-id="element-49">
              Privacy
            </a>
            <a href="#" className="hover:text-gray-900 transition-colors" data-id="element-50">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>;
};